import {apiService} from '../../helpers/axios'
import {ParamsRequestGetList, ResponseApi} from '../models/_public'

export function fetchCohortGraph(params: ParamsRequestGetList): Promise<ResponseApi<any>> {
  return apiService.get('/reports/user/device-cohort', {params})
}
